import React from "react";
import { Hero } from "../components/Hero";
import { IntroSection } from "../components/IntroSection";
import { BeforeAfterSection } from "../components/BeforeAfterSection";
import { ChallengesSection } from "../components/ChallengesSection";
import { VolumesSection } from "../components/VolumesSection";
import { BonusesSection } from "../components/BonusesSection";
import { OfferSection } from "../components/OfferSection";
import { LaunchSection } from "../components/LaunchSection";
import { DecisionSection } from "../components/DecisionSection";
import { ApproachSection } from "../components/ApproachSection";
import { TestimonialsSection } from "../components/TestimonialsSection";
import { AuthorSection } from "../components/AuthorSection";
import { FAQSection } from "../components/FAQSection";
import { Footer } from "../components/Footer";
import { FloatingCTA } from "../components/FloatingCTA";
import { PurchasePopup } from "../components/PurchasePopup";
export function Landing() {
  return <div className="min-h-screen w-full overflow-x-hidden bg-navy-950" data-id="element-332" data-mp="2b3a4ch2mkm4">
      <Hero data-id="element-333" data-mp="3tgl6dd6on5xy" />
      <main data-id="element-334" data-mp="3tg204tqea5zr">
        <IntroSection data-id="element-335" data-mp="3tfa27c9brw6b" />
        <BeforeAfterSection data-id="element-336" data-mp="3tf0btnkdbn03" />
        <ChallengesSection data-id="element-337" data-mp="3peq86hk1t8oe" />
        <VolumesSection data-id="element-338" data-mp="3pdyc75mjh8xl" />
        <BonusesSection data-id="element-339" data-mp="3pf9qw0hiw13h" />
        <OfferSection data-id="element-340" data-mp="3pgubaxa4i3nm" />
        <LaunchSection variant="launch" data-id="element-341" data-mp="3kfwryhddn3kj" />
        <DecisionSection data-id="element-342" data-mp="3kgyf3k7o3gim" />
        <ApproachSection data-id="element-343" data-mp="3khq2i7r427xt" />
        <TestimonialsSection data-id="element-344" data-mp="l09yaf0mw4fb" />
        <AuthorSection data-id="element-345" data-mp="kzgm2yiwomps" />
        <FAQSection data-id="element-346" data-mp="l002ubwtl528" />
        <LaunchSection variant="final" data-id="element-347" data-mp="l2cmcti87nhe" />
      </main>
      <Footer data-id="element-348" data-mp="gzzhe7baztlo" />
      <FloatingCTA data-id="element-349" data-mp="gzgb5nv0mtnh" />
      <PurchasePopup data-id="element-350" data-mp="h113r7xrs2ip" />
    </div>;
}